module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-screen",
    attrs: {
      "id": "bigScreen"
    }
  }, [_c('div', {
    staticClass: "modify-wrap"
  }, [_c('el-button', {
    staticClass: "upLoad",
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.coverImg
    }
  }, [_c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v("上传背景")]), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("填写或选择机位占用颜色:\n      "), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "机位颜色值..."
    },
    model: {
      value: (_vm.form.computerFillColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerFillColor", $$v)
      },
      expression: "form.computerFillColor"
    }
  }), _vm._v(" "), _c('el-color-picker', {
    on: {
      "change": _vm.changeComputerColor
    },
    model: {
      value: (_vm.form.computerFillColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerFillColor", $$v)
      },
      expression: "form.computerFillColor"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("填写或选择字体颜色:\n      "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "字体颜色值..."
    },
    model: {
      value: (_vm.form.computerTextColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerTextColor", $$v)
      },
      expression: "form.computerTextColor"
    }
  }), _vm._v(" "), _c('el-color-picker', {
    on: {
      "change": _vm.changeComputerTextColor
    },
    model: {
      value: (_vm.form.computerTextColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerTextColor", $$v)
      },
      expression: "form.computerTextColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "size",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("机位样式大小：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "min": 0,
      "max": 500,
      "show-input": ""
    },
    on: {
      "change": _vm.changeComputerNodeSize
    },
    model: {
      value: (_vm.form.computerNodeSize),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerNodeSize", $$v)
      },
      expression: "form.computerNodeSize"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doShowDrawer.apply(null, arguments)
      }
    }
  }, [_vm._v("选择机位")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制大屏链接")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openBigScreen
    }
  }, [_vm._v("查看大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "opacity": "0"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openBigScreenForAd
    }
  }, [_vm._v("大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "0",
      "height": "0",
      "font-size": "0",
      "opacity": "0"
    },
    attrs: {
      "id": "copyData"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bigScreenUrl) + "\n    ")]), _vm._v(" "), (!_vm.noData) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n      双击机位图标可进行旋转和键盘细微移动，右键可进行删除\n    ")]) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v("暂未上传任何机位大屏信息")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "out-wrap",
    style: (_vm.showDrawer ? 'padding-right:450px' : '')
  }, [_c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "canvasWrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "context-menu",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "del",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delNode.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "context-menu-extra",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "del",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addExtra('text')
      }
    }
  }, [_vm._v("插入文本")]), _vm._v(" "), _c('div', {
    staticClass: "del",
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('input', {
    staticClass: "upImage",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.upImage
    }
  }), _vm._v("\n        插入图片\n      ")])])]), _vm._v(" "), (_vm.showDrawer) ? _c('div', {
    staticClass: "drawer-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("选择机位")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDrawer = false
      }
    }
  }, [_vm._v("关闭")])]), _vm._v(" "), _c('div', {
    staticClass: "drawer-cont"
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.sites), function(it, ind) {
    return _c('el-collapse-item', {
      key: ind,
      attrs: {
        "title": ("" + (it.name)),
        "name": ("" + (it.id))
      }
    }, _vm._l((it.nums), function(ite, inde) {
      return _c('div', {
        key: ("c_" + inde),
        staticClass: "site-img"
      }, [_c('img', {
        attrs: {
          "draggable": "true",
          "src": "/static/bigScreen/assets/computer_free.png",
          "data-ipAddress": ("" + (ite.ipAddress)),
          "data-ipNo": ("" + (_vm.computedIpNo(ite.ipAddress))),
          "data-fillName": ("" + (_vm.computedIpNo(ite.name))),
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ip"
      }, [_vm._v(_vm._s(ite.ipAddress))])])
    }), 0)
  }), 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showExtra) ? _c('div', {
    staticClass: "my-dialog",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showExtra = false;
      }
    }
  }, [_c('div', {
    staticClass: "inner-dialog",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.extraType == 'text') ? [_c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请输入文本内容：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.textVal),
      callback: function($$v) {
        _vm.textVal = $$v
      },
      expression: "textVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请选择字体颜色：")]), _vm._v(" "), _c('el-color-picker', {
    model: {
      value: (_vm.textColor),
      callback: function($$v) {
        _vm.textColor = $$v
      },
      expression: "textColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("字体效果：")]), _vm._v(" "), _c('div', {
    style: (("color:" + _vm.textColor + ";font-size:30px;"))
  }, [_vm._v("\n            " + _vm._s(_vm.textVal) + "\n          ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showExtra = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doAddExtra
    }
  }, [_vm._v("创 建")])], 1)], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-734ae8b6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/bigScreen/index.vue
// module id = 962
// module chunks = 1